import styled from "styled-components";

import PDFIcon from "../../images/icon_pdf.svg";
import GrayPDFIcon from "../../images/icon_pdf_disabled.png";
import { TOOLTIPS } from "../../utils/tooltipConstants";
import { BaseButton } from "./BaseButton";

const IconButton = styled(BaseButton)`
  background-color: transparent;
`;

export function ExportButton(props: any) {
  const { tooltipText, onClick, altText, disabled } = props;
  const tooltipContent = tooltipText ? tooltipText : TOOLTIPS.download.text;
  const alt = altText ? altText : tooltipContent;
  return (
    <IconButton
      onClick={!disabled ? onClick : () => {}}
      tooltip={tooltipContent}
    >
      <img src={!disabled ? PDFIcon : GrayPDFIcon} alt={alt} />
    </IconButton>
  );
}
